import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";
import { SERVICE_META } from "../i18n/translations";
import { ICONS, PageHero, Reveal } from "../components/shared";
import { SERVICE_IMAGES, IMAGES } from "../constants/images";

export default function Services() {
  const { t } = useLang();

  return (
    <div data-testid="services-page">
      <PageHero tag={t.homeServices.tag} title={t.services.heroTitle} subtitle={t.services.heroSubtitle} image={IMAGES.cyber} />

      <section className="relative py-16">
        <div className="max-w-7xl mx-auto px-6 md:px-12 space-y-8">
          {SERVICE_META.map((meta, i) => {
            const Icon = ICONS[meta.icon];
            const svc = t.services.items[meta.key];
            const reverse = i % 2 === 1;
            return (
              <Reveal key={meta.key} delay={0.04}>
                <div
                  data-testid={`service-card-${meta.key}`}
                  className="grid lg:grid-cols-2 gap-10 items-center rounded-[2rem] border border-white/10 bg-[#0F0F12] overflow-hidden p-4 lg:p-0"
                >
                  <div className={`relative h-64 lg:h-[380px] rounded-2xl lg:rounded-none overflow-hidden ${reverse ? "lg:order-2" : ""}`}>
                    <img src={SERVICE_IMAGES[i]} alt={svc.name} className="w-full h-full object-cover" />
                    <div className="absolute inset-0 bg-gradient-to-t from-[#0F0F12] via-transparent to-transparent" />
                  </div>
                  <div className={`p-4 lg:p-12 ${reverse ? "lg:order-1" : ""}`}>
                    <div className="flex items-center justify-center w-12 h-12 rounded-xl bg-[#1E90FF]/10 border border-[#1E90FF]/20 text-[#1E90FF]">
                      <Icon className="h-6 w-6" />
                    </div>
                    <h2 className="mt-5 text-2xl md:text-3xl font-bold text-white">{svc.name}</h2>
                    <p className="mt-1.5 font-mono text-xs uppercase tracking-wider text-[#00E5FF]">{svc.tagline}</p>
                    <p className="mt-4 text-zinc-400 leading-relaxed">{svc.description}</p>
                    <ul className="mt-6 grid sm:grid-cols-2 gap-3">
                      {svc.features.map((f, fi) => (
                        <li key={fi} className="flex items-center gap-2.5 text-sm text-zinc-300">
                          <span className="flex items-center justify-center w-5 h-5 rounded-full bg-[#1E90FF]/15 text-[#1E90FF] shrink-0">
                            <Check className="h-3 w-3" />
                          </span>
                          {f}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </section>

      <section className="relative py-20">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <Reveal>
            <div className="rounded-[2rem] border border-white/10 bg-gradient-to-br from-[#0d1b2e] to-[#0F0F12] p-12 text-center relative overflow-hidden">
              <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[400px] h-[260px] bg-[#1E90FF]/20 blur-[100px] rounded-full" />
              <h2 className="relative text-2xl md:text-3xl font-bold text-white max-w-2xl mx-auto">{t.cta.title}</h2>
              <p className="relative mt-4 text-zinc-400 max-w-xl mx-auto">{t.cta.text}</p>
              <Link to="/contact" data-testid="services-cta-contact" className="relative mt-7 inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-[#1E90FF] hover:bg-[#3B82F6] text-white font-semibold transition-all hover:-translate-y-0.5">
                {t.cta.button} <ArrowRight className="h-5 w-5" />
              </Link>
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
